/* eslint-disable global-require */
import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth';

import router from './router';

function scheduleRequests(axiosInstance, intervalMs) {
  let lastInvocationTime;

  const scheduler = (config) => {
    const now = Date.now();
    if (lastInvocationTime) {
      lastInvocationTime += intervalMs;
      const waitPeriodForThisRequest = lastInvocationTime - now;
      if (waitPeriodForThisRequest > 0) {
        return new Promise((resolve) => {
          setTimeout(
            () => resolve(config),
            waitPeriodForThisRequest,
          );
        });
      }
    }

    lastInvocationTime = now;
    return config;
  };

  axiosInstance.interceptors.request.use(scheduler);
}

scheduleRequests(axios, 100);

axios.defaults.baseURL = Vue.prototype.$api;

axios.interceptors.response.use(
  response => response,
  error => {
    // console.log('axios.error', error.response.data);
    if (error.response.data === 'maintenance-mode') {
      alert('Nomad Soulmates is being updated and will be back shortly');
    }
    return Promise.reject(error);
  },
);

window.axios = axios; // important for vue-tables-2

Vue.router = router; // important for vue-auth

Vue.use(VueAxios, axios);
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),

  loginData: {
    url: '/api/auth/login',
    method: 'POST',
    redirect: '/',
    fetchUser: false,
  },

  registerData: {
    url: '/api/auth/register',
    method: 'POST',
    redirect: '/',
    fetchUser: false,
  },

  logoutData: {
    url: '/api/auth/logout',
    method: 'GET',
    // redirect: '/login',
    makeRequest: true,
  },

  refreshData: {
    url: '/api/auth/refresh',
    method: 'GET',
    enabled: false,
    interval: 30,
    error() {
      window.localStorage.clear();
      window.location = `${URL}login`;
    },
  },

  fetchData: {
    url: '/api/auth/user',
    method: 'GET',
    enabled: true,
  },

});
